import { MfaCodeFormShared } from '@liscio/common';
import { TextField } from '@liscio/ui';

export interface MfaFormInterface {
  mfaCode: string;
}

export interface MfaCodeFormProps {
  isLoading?: boolean;
  onSubmit: (data: MfaFormInterface) => void;
  backToLogin: () => void;
  /** Sends a magic link to the email used at sign-in (e.g. if the user has no phone auth app). */
  onRequestMagicLink?: () => void;
}

export const MfaCodeForm = ({
  isLoading,
  onSubmit,
  backToLogin,
  onRequestMagicLink,
}: MfaCodeFormProps) => {
  return (
    <MfaCodeFormShared
      isLoading={isLoading}
      onSubmit={onSubmit}
      backToLogin={backToLogin}
      onRequestMagicLink={onRequestMagicLink}
      renderCodeInput={({ registerMfaCode, errorMessage }) => (
        <TextField
          {...registerMfaCode('mfaCode')}
          fullWidth
          placeholder="6-digit code"
          inputProps={{ maxLength: 6, inputMode: 'numeric', pattern: '[0-9]*' }}
          error={Boolean(errorMessage)}
          helperText={errorMessage}
        />
      )}
    />
  );
};
